import Locale, { LocaleValues, SupportedHomeLocales, SupportedBusinessLocales } from './Locale';
import { PAGE, MarketingPageAvailability } from './MarketingPages';
export default function interpolateLinkForLocale(link, locale) {
  var availableLocale = LocaleValues.includes(locale) ? locale : Locale.GB;
  var availableHomeLocale = Object.values(SupportedHomeLocales).includes(locale) ? locale : Locale.GB;
  var availableBusinessLocale = Object.values(SupportedBusinessLocales).includes(locale) ? locale : Locale.GB;
  var variables = [{
    string: '/:localePath/large-amounts/',
    value: availableLocale === Locale.GB ? '/large-amounts/' : "/".concat(availableLocale, "/large-amounts/")
  },
  // TODO remove once /gb/ supported for large-amounts
  {
    string: '/:localePath/local-sites',
    value: availableLocale === Locale.GB ? '/local-sites' : "/".concat(availableLocale, "/local-sites")
  },
  // TODO remove once /gb/ supported for local-sites
  {
    string: '/:localePath/terms-of-use',
    value: availableLocale === Locale.GB ? '/terms-of-use' : "/".concat(availableLocale, "/terms-of-use")
  },
  // TODO remove once /gb/ supported for terms-of-use
  {
    string: '/:locale/card/',
    value: MarketingPageAvailability[PAGE.CARD].indexOf(locale) > -1 ? "/".concat(locale, "/card/") : "/gb/card/"
  }, {
    string: '/:locale/account/',
    value: MarketingPageAvailability[PAGE.ACCOUNT].indexOf(locale) > -1 ? "/".concat(locale, "/account/") : "/gb/account/"
  }, {
    string: /^\/:localePath\/$/,
    value: availableHomeLocale === Locale.GB ? '/' : "/".concat(availableHomeLocale, "/")
  }, {
    string: '/:localePath/',
    value: availableBusinessLocale === Locale.GB ? '/' : "/".concat(availableBusinessLocale, "/")
  }, {
    string: ':locale',
    value: availableLocale
  }];
  return variables.reduce(function (result, _ref) {
    var string = _ref.string,
      value = _ref.value;
    return result.replace(string, value);
  }, link);
}
export function interpolateLinkForRegion(link, region) {
  return link.replace(':region', region);
}